
export default {
    count_regex_match: function(str,regex_pattern) {
        const re = regex_pattern
        return ((str || '').match(re) || []).length
    },
    handlebars_bracket_replace: function (template, data, template_fallback) {
        //(this.active_script.script_text_handlebars, this.active_contact, this.active_script.script_text_fallback);
  
        'use strict';

   

        try {
            if(!template || template === null || template === '' || template === undefined) {
                return template_fallback
            }
        
            // Check if the template is a string or a function
            template = typeof (template) === 'function' ? template() : template;
            if (['string', 'number'].indexOf(typeof template) === -1) throw 'handlebars_bracket_replace: please provide a valid template';
        
            // If no data, return template as-is
            if (!data) return template_fallback;
        
            // Replace our curly braces with data
            let number_of_handlebars = this.count_regex_match(template,/\{\{([^}]+)\}\}/g) 
            //console.log(number_of_handlebars)

            let count_correct_handlebars_replacements = 0

            template = template.replace(/\{\{([^}]+)\}\}/g, function (match) {



                //console.log('debug 23 match ' + match)
        
                // Remove the wrapping curly braces
                match = match.slice(2, -2);
                //console.log(match)

                // Check if the item has sub-properties
                var sub = match.split('.');
                //console.log(JSON.stringify(sub))

                //console.log(JSON.stringify(data))
                //console.log(data[match])
               // if(!data[match] || data[match] === undefined || data[match] === null) {
                //    console.log('debug there is no data to match this handlebars item data[match]')
                    //return template_fallback
                //}
        
                // If the item has a sub-property, loop through until you get it
                if(data[match] !== null && typeof data[match] !== 'undefined') {
                   // console.log('has data[match]')
                    //console.log(data[match])
                    count_correct_handlebars_replacements = count_correct_handlebars_replacements+1
                    return data[match]
                } else if (sub.length > 1) {
                   // console.log('there is a dot')
                   // console.log(sub[0])
                    //console.log(sub[1])
                    //console.log(data[sub[0]])

                    let first_object_name = sub[0]
                    let second_object_name = sub[1]


                    //should be the first object name
                    if(typeof data[first_object_name] !== 'undefined') {
                        //console.log(data[first_object_name])
                        //hack to get real object?
                        
                        //console.log(data[first_object_name])
                        //console.log(second_object_name)
                        if(typeof data[first_object_name][second_object_name] !== 'undefined') {
                            
                            //console.log(data[first_object_name][second_object_name])
                            if(data[first_object_name][second_object_name] === null ) {
                                return template_fallback
                            } else {
                                count_correct_handlebars_replacements = count_correct_handlebars_replacements+1
                                return data[first_object_name][second_object_name]
                            }
                            
                        } else {
                            //console.log('no match here is fallback')
                            //console.log(template)
                            return template_fallback
                        }
                    } else {
                        return template_fallback
                    }

                } else {
                    //console.log('i think there is no match?')
                    return template_fallback
                }
        
                // Otherwise, return the item
                //else {
                //    if (!data[match]) return '{{' + match + '}}';
                //    return data[match];
               // }
        
            });

            //console.log(template)
            //console.log(number_of_handlebars)
            //console.log(count_correct_handlebars_replacements)
            if(number_of_handlebars === count_correct_handlebars_replacements) {
                return template;
            } else {
                return template_fallback
            }
            
        } catch(e) {
            console.log(e)
            return template_fallback
        }
        
    
    }//handlebars_bracket_replace

    /*
    handlebars_bracket_replace: function (template, data, template_fallback) {
        //(this.active_script.script_text_handlebars, this.active_contact, this.active_script.script_text_fallback);
  
        'use strict';

         

        try {
            if(!template || template === null || template === '' || template === undefined) {
                return template_fallback
            }
        
            // Check if the template is a string or a function
            template = typeof (template) === 'function' ? template() : template;
            if (['string', 'number'].indexOf(typeof template) === -1) throw 'handlebars_bracket_replace: please provide a valid template';
        
            // If no data, return template as-is
            if (!data) return template_fallback;
        
            // Replace our curly braces with data
            template = template.replace(/\{\{([^}]+)\}\}/g, function (match) {



                console.log('debug 23 match ' + match)
        
                // Remove the wrapping curly braces
                match = match.slice(2, -2);
                console.log(match)

                // Check if the item has sub-properties
                var sub = match.split('.');
                console.log(JSON.stringify(sub))

                console.log(JSON.stringify(data))
                console.log(data[match])
               // if(!data[match] || data[match] === undefined || data[match] === null) {
                //    console.log('debug there is no data to match this handlebars item data[match]')
                    //return template_fallback
                //}
        
                // If the item has a sub-property, loop through until you get it
                if(data[match] !== null && typeof data[match] !== 'undefined') {
                   // console.log('has data[match]')
                    //console.log(data[match])
                    return data[match]
                } else if (sub.length > 1) {
                   // console.log('there is a dot')
                   // console.log(sub[0])
                    //console.log(sub[1])
                    //console.log(data[sub[0]])

                    let first_object_name = sub[0]
                    let second_object_name = sub[1]


                    //should be the first object name
                    if(typeof data[first_object_name] !== 'undefined') {
                        console.log(data[first_object_name])
                        //hack to get real object?
                        
                        console.log(data[first_object_name])
                        console.log(second_object_name)
                        if(typeof data[first_object_name][second_object_name] !== 'undefined') {
                            
                            console.log(data[first_object_name][second_object_name])
                            if(data[first_object_name][second_object_name] === null ) {
                                return template_fallback
                            } else {
                                return data[first_object_name][second_object_name]
                            }
                            
                        } else {
                            console.log('no match here is fallback')
                            console.log(template)
                            return template_fallback
                        }
                    } else {
                        return template_fallback
                    }

                    
        
                } else {
                    console.log('i think there is no match?')
                    return template_fallback
                }
        
                // Otherwise, return the item
                //else {
                //    if (!data[match]) return '{{' + match + '}}';
                //    return data[match];
               // }
        
            });

            console.log(template)
            return template;
        } catch(e) {
            console.log(e)
            return template_fallback
        }
        
    
    }//handlebars_bracket_replace
    */
}